import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import ChatPanel from '../components/ChatPanel'
import Sidebar from '../components/Sidebar'
import RightSidebar from '../components/RightSidebar'
import { v4 as uuidv4 } from 'uuid';
import ConversationAPI from '../api/conversationApi';
import DocumentAPI from '../api/documentApi';
import ChatAPI from '../api/chatApi';
import Help from '../constant/help';
import { query, orderByChild, startAt, onChildAdded, ref as dbRef } from "firebase/database";
import { db } from '../constant/firebase';
import NoteAPI from '../api/noteApi';
import { useTranslation } from 'react-i18next';
import LoadingPage from '../components/LoadingPage';
import toast from 'react-hot-toast';
import ConfigChatwebAPI from '../api/configChatwebApi';

const ChatPage = () => {
  const config = window.__VIETRADE_CHAT_CONFIG__ || {};
  const { applicationID, channelId, baseUrl } = config;

  const [conversationId, setConversationId] = useState(null);
  const [visitorId, setVisitorId] = useState(null);

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [chatKey, setChatKey] = useState(Date.now());
  const chatEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true)
  const [loadingConversations, setLoadingConversations] = useState({}); 

  const [pageMessageHistory, setPageMessageHistory] = useState(0);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [isFetchingChat, setIsFetchingChat] = useState(false);
  const pendingScrollForChatId = useRef(null);
  const skipScrollOnHistoryLoad = useRef(false);
  const scrollHeightBeforeLoad = useRef(0);

  const [activeRightSection, setActiveRightSection] = useState("documents"); //"documents" | "notes" | null

  //state management file
  const [fileUrl, setFileUrl] = useState("");
  const [documentFiles, setDocumentFiles] = useState([]);
  const [selectedFileForChat, setSelectedFileForChat] = useState(null);
  const fileInputRef = useRef(null);

  //state management note
  const [noteList, setNoteList] = useState([]);
  const [newNoteTitle, setNewNoteTitle] = useState('');
  const [newNoteContent, setNewNoteContent] = useState('');
  const [isAddingNote, setIsAddingNote] = useState(false)
  const [editingNoteId, setEditingNoteId] = useState(null)

  //state management conversation
  const [conversationList, setConversationList] = useState([]);
  const [selectedConversationId, setSelectedConversationId] = useState(null);

  const [currentChatId, setCurrentChatId] = useState(null)

  const [showSidebar, setShowSidebar] = useState(false)
  const [showRightSidebar, setShowRightSidebar] = useState(false)
  const [desktopSidebarCollapsed, setDesktopSidebarCollapsed] = useState(false)

  //Config Chatweb
  const [configChatweb, setConfigChatweb] = useState(null);

  // Lưu timeout để detect bot đã dừng stream
  const botStreamTimeout = useRef(null);

  const { t } = useTranslation();

  localStorage.setItem("channelId", channelId);
  // localStorage.setItem("conversationId", conversationId);
   useEffect(() => {
    if (visitorId) {
      localStorage.setItem("visitorId", visitorId);
    }
  }, [visitorId]);

  const mapMessagesFromApi = (rawMessages) => {
    // return [...rawMessages].reverse();
    const msgs = [...rawMessages].reverse().map((m) => ({
      ...m,
      isStreaming: false,
      isHistorical: true,
    }));
    return mergeMessages(msgs);
  };

  // Gom bot message liên tiếp thành 1 bubble
  const mergeMessages = (messages) => {
    const result = [];
    const TIME_THRESHOLD = 60000; // 60s to ensure long responses stay together

    const getTime = (dateVal) => {
      if (!dateVal) return 0;
      if (dateVal.time) return dateVal.time;
      const d = new Date(dateVal);
      return isNaN(d.getTime()) ? 0 : d.getTime();
    };

    messages.forEach((m) => {
      const last = result[result.length - 1];

      const isSameActor =
        last &&
        !m.isCustomer &&
        !last.isCustomer;

      const isCloseTime =
        last &&
        Math.abs(getTime(m.createdAt) - getTime(last.createdAt)) < TIME_THRESHOLD;

      if (isSameActor && isCloseTime) {
        result[result.length - 1] = {
          ...last,
          createdAt: m.createdAt,
          mode: m.mode || last.mode,
          message: `${last.message || ""}${m.message || ""}\n`,
        };
      } else {
        result.push({
          ...m,
          message: !m.isCustomer ? `${m.message}\n` : m.message,
        });
      }
    });

    return result;
  };

  // const mergeMessages = (messages) => {
  //   const result = [];

  //   messages.forEach((m) => {
  //     const last = result[result.length - 1];

  //   //   if (Help.canGroup(last, m)) {
  //   //     result[result.length - 1] = {
  //   //       ...last,
  //   //       message: `${last.message || ""}${m.message || ""}\n`,
  //   //     };
  //   //   } else {
  //   //     result.push({
  //   //       ...m,
  //   //       message: !m.isCustomer ? `${m.message}\n` : m.message,
  //   //     });
  //   //   }
  //   // });
  //   // return result;
  //     if (
  //       last &&
  //       !m.isCustomer &&
  //       !last.isCustomer
  //     ) {
  //       result[result.length - 1] = {
  //         ...last,
  //         message: `${last.message || ""}${m.message || ""}\n`,
  //       };
  //     } else {
  //       result.push({
  //         ...m,
  //         message: !m.isCustomer ? `${m.message}\n` : m.message,
  //       });
  //     }
  //   });

  // return result;
  // };

  useEffect(() => {
    const fetchVisitorId = async () => {
      if (
        window.__VIETRADE_CHAT_CONFIG__ &&
        typeof window.__VIETRADE_CHAT_CONFIG__.getVisitorId === "function"
      ) {
        const id = await window.__VIETRADE_CHAT_CONFIG__.getVisitorId();
        setVisitorId(id);
      }
    };

    fetchVisitorId();
  }, []);

  const handleNewChat = async () => {
    setSelectedConversationId(null)
    setConversationId(null)
    setMessages([])
    setSelectedFileForChat(null)
    setDocumentFiles([])
    setInput("")
    setPageMessageHistory(0)
    
  };

  const handleScroll = async () => {
    const node = chatContainerRef.current;
    if (!node || node.scrollTop !== 0 || loadingHistory) return;

    //prevent load page 0 dubble
    if (!conversationId || pageMessageHistory === 0) return;

    setLoadingHistory(true);
    skipScrollOnHistoryLoad.current = true;
    scrollHeightBeforeLoad.current = node.scrollHeight;    

    try {
      if(!conversationId) return;

      const history = await ChatAPI.getChatHistories(conversationId, pageMessageHistory);
      if (history?.messages?.length > 0) {
        const mapped = mapMessagesFromApi(history?.messages);

        // setMessages((prev) => [...mapped, ...prev]);
        setMessages((prev) => mergeMessages([...mapped, ...prev]));

        setPageMessageHistory((prev) => prev + 1);
        setTimeout(() => {
        const newScrollHeight = node.scrollHeight;
        node.scrollTop = newScrollHeight - scrollHeightBeforeLoad.current;
        }, 50);
      }
    } catch (err) {
      console.error("Lỗi khi tải thêm lịch sử:", err);
    }
    setLoadingHistory(false);
    setTimeout(() => {
      skipScrollOnHistoryLoad.current = false;
    }, 200);
  };

  // MANAGEMENT CONVERSATION
  const refreshConversationList = async () => {
    if (!channelId || !visitorId) return

    try {
      const conversations = await ConversationAPI.getConversation({ channelId, visitorId })

      const sorted = [...conversations].sort((a, b) => {
        const timeA = new Date(a.updatedAt || a.createdAt).getTime();
        const timeB = new Date(b.updatedAt || b.createdAt).getTime();
        return timeB - timeA; 
      });

      setConversationList(sorted);

    } catch (error) {
      console.error("Lỗi khi refresh danh sách hội thoại:", error)
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }

  // Load danh sách conversation khi có visitorId và channelId
  useEffect(() => {
    if (channelId && visitorId) {
      refreshConversationList()
    }
  }, [channelId, visitorId])

  const handleSelectConversation = async (conversationId) => {
    setCurrentChatId(conversationId)
    setSelectedConversationId(conversationId);
    setConversationId(conversationId); 
    setMessages([]);
    setIsFetchingChat(true);

    if(!conversationId) {
      setIsFetchingChat(false);
      return;
    }
    try {
      pendingScrollForChatId.current = conversationId;
      const history = await ChatAPI.getChatHistories(conversationId, 0);
      setMessages(mapMessagesFromApi(history.messages));
      setPageMessageHistory(1);
    } catch (err) {
      console.error("Lỗi khi tải hội thoại:", err);
      pendingScrollForChatId.current = null;
    } finally {
      setIsFetchingChat(false);
    }
  };

  const handleDeleteChatConversation = async (conversationId) => {
    try {
      if (!conversationId) return;

      // Xoá ngay trong local state để cập nhật UI
      setConversationList((prev) =>
        prev.filter((conv) => conv.id !== conversationId)
      );

      // Nếu đang xoá conversation đang mở thì reset
      if (currentChatId === conversationId) {
        handleNewChat();
        setCurrentChatId(null);
        setConversationId(null);
        setSelectedConversationId(null);
        localStorage.removeItem("conversationId");
      }
      await ConversationAPI.deleteConversation(conversationId);
      toast.success(t('chatpanel.conv.delete_success'));
    } catch (error) {
      console.error("handleDeleteChatConversation error:", error);
      toast.error(t('chatpanel.conv.delete_fail'));
    }
  };

  const handleEditChatTitle = async (conversationId, newTitle) => {
    if (!conversationId || !newTitle?.trim()) return;

    try {
      await ConversationAPI.editConversationTitle(conversationId, newTitle);
      setConversationList((prev) =>
        prev.map((conv) =>
          conv.id === conversationId ? { ...conv, firstMessage: newTitle } : conv
        )
      );
      toast.success(t('chatpanel.conv.edit_title_success'));
    } catch (error) {
      console.error("Lỗi cập nhật title:", error);
      toast.error(t('chatpanel.conv.edit_title_fail'));
    }
  };

   //FILE MANAGEMENT
  const handleFileUpload = async (fileList, selectFirst = false) => {
    const files = Array.from(fileList);

    // File để upload (tên đã slug)
    const slugFiles = files.map((file) => {
      const newName = Help.formatFileName(file.name);
      return new File([file], newName, { type: file.type });
    });

    // Hiển thị tạm thời với title gốc
    const tempFiles = files.map((file) => ({
      id: file.name + Date.now(),
      title: file.name, 
      size: Math.round(file.size / 1024),
      status: "uploading",
    }));

    setActiveRightSection('documents');
    setDocumentFiles((prev) => [...tempFiles, ...prev]);

    if (selectFirst && tempFiles.length > 0) {
      const firstTemp = tempFiles[0];
      setSelectedFileForChat(firstTemp);
    }

    try {
      const res = await DocumentAPI.uploadDocument({
        files: slugFiles,
        conversationId,
        userId: visitorId,
      });

      const uploadedFiles = (res.success || []).map((f, i) => ({
        ...f,
        title: files[i].name,
        status: "ready",
      }));

      const failedFiles = (res.error || []).map((f) => ({
        id: f.title + Date.now(),
        title: f.title,
        message: f.message,
        status: "failed",
      }));

      const finalFiles = [
        ...uploadedFiles,
        ...failedFiles,
        ...documentFiles.filter((f) => f.status !== "uploading"),
      ];

      setDocumentFiles(finalFiles);

      // Nếu gọi với selectFirst = true thì chọn file đầu tiên luôn
      if (selectFirst && uploadedFiles.length > 0) {
        const firstFile = uploadedFiles[0];
        setSelectedFileForChat(firstFile);
        setInput(`${t('chatpanel.chat_input_file')} ${decodeURIComponent(firstFile.title)}`);
        setDocumentFiles([firstFile, ...finalFiles.filter(f => f.id !== firstFile.id)]);
      }

    } catch (err) {
      console.error("Upload error:", err);
      setDocumentFiles((prev) =>
        prev.map((f) =>
          f.status === "uploading"
            ? { ...f, status: "failed", message: "Lỗi upload" }
            : f
        )
      );
      if (selectFirst) {
        setSelectedFileForChat((prev) =>
          prev ? { ...prev, status: "failed" } : prev
        );
      }
    }
  };

  const fetchDocuments = async () => {
    try {
      const res = await DocumentAPI.getAllDocument(conversationId);

      setDocumentFiles((prev) => {
        const docs = (res.content || []).map((doc) => {
          const old = prev.find((f) => f.id === doc.id);
          return {
            ...doc,
            status: "ready", 
          };
        });

        return docs;
      });
    } catch (err) {
      console.error("fetchDocuments error:", err);
    }
  };

  const handleSelect = (fileId) => {
    const file = documentFiles.find((f) => f.id === fileId);
    if (!file) return;

    // Nếu đang chọn chính file đó → bỏ chọn và restore danh sách ban đầu
    if (selectedFileForChat?.id === fileId) {
      setSelectedFileForChat(null);
      setInput("");

      // (Optional) sắp xếp lại nếu muốn quay về trạng thái ban đầu
      setDocumentFiles([...documentFiles]); 
      return;
    }

    // Đưa file được chọn lên đầu danh sách
    const newList = [
      file,
      ...documentFiles.filter((f) => f.id !== fileId),
    ];
    setSelectedFileForChat(file);
    setDocumentFiles(newList);
    setInput(`${t('chatpanel.chat_input_file')} ${decodeURIComponent(file.title)}`);
  };

  const handleDeleteDocument = async (docId) => {
    try {
      await DocumentAPI.deleteDocument(conversationId, docId);
      setSelectedFileForChat(null)
      setInput("")
      fetchDocuments(); // refresh danh sách
      toast.success(t('chatpanel.documents.delete_success'));
    } catch (err) {
      console.error('err delete file', err);
      toast.error(t('chatpanel.documents.delete_fail'));
    }
  };

  //NOTE MANAGEMENT
   const fetchNotes = async () => {
    try {
      const res = await NoteAPI.getAllNote(conversationId);
      setNoteList(res.content)

      return res.content;
    } catch (err) {
      console.error("fetchDocuments error:", err);
    }
  };

  useEffect(() => {
    if (!conversationId) return;
      fetchDocuments();
      fetchNotes()
  }, [conversationId]);
 
  const handleAddNote = async () => {
    if (!newNoteContent || !newNoteTitle) {
      toast.error(t('right_sidebar.manage_note.note_empty'));
      return;
    }
    if (!conversationId) {
      toast.error(t('right_sidebar.manage_note.create_conv'));
      return;
    }
    try {
        const res = await NoteAPI.createNote({
          conversationId,
          visitorId,
          title: newNoteTitle,
          content: newNoteContent
        })
        setNewNoteContent('');
        setNewNoteTitle('');
        setIsAddingNote(false)

        fetchNotes()

        toast.success(t('right_sidebar.manage_note.add_note_success'));

        return res;
    } catch (error) {
        console.error('error handelAddNote', error);
        toast.error(t('right_sidebar.manage_note.add_note_failed'));
    }
  }

  const handleEditNote = async (noteId) => {
    try {
      const editNote = await NoteAPI.getNoteDetail(conversationId, noteId)
      if(editNote){
        setEditingNoteId(editNote.id)
        setNewNoteContent(editNote.content)
        setNewNoteTitle(editNote.title)
        setIsAddingNote(true)
      }
      
    } catch (error) {
      console.error("handleEditNote error", error);
    }
  }
  
  const handleSaveEditedNote = async () => {
    try {
      if (editingNoteId && newNoteTitle.trim() && newNoteContent.trim()) {
        await NoteAPI.editNote(editingNoteId, {
          title: newNoteTitle,
          content: newNoteContent,
          updatedAt: new Date(),
        });

        setNewNoteContent('');
        setNewNoteTitle('');
        setEditingNoteId(null);
        setIsAddingNote(false);
        fetchNotes();
        toast.success(t('chatpanel.notes.edit_success'));
      }
    } catch (error) {
      console.error('Lỗi khi lưu ghi chú đã chỉnh sửa:', error);
      toast.error(t('chatpanel.notes.edit_fail'));
    }
  };

  const handleDeleteNote = async (noteId) => {
    try {
      await NoteAPI.deleteNote(conversationId, noteId);
      
      fetchNotes(); // refresh danh sách
      toast.success(t('chatpanel.notes.delete_success'));
    } catch (err) {
      console.error('err delete note', err);
      toast.error(t('chatpanel.notes.delete_fail'));
    }
  };

  const handleSaveMessageToNote = async (message) => {
    if (!conversationId || !visitorId || !message) return;

    const newTime = new Date()

    const noteTitle =
        `${t('right_sidebar.manage_note.note_from')} ${message.isCustomer === true ? t('right_sidebar.manage_note.user') : "VietradeAI"} - ${Help.formatCreatedAt(newTime)}`
    try {
      await NoteAPI.createNote({
        conversationId,
        visitorId,
        title: noteTitle,
        content: message.message
      })
      setActiveRightSection('notes')
      toast.success(t('right_sidebar.manage_note.add_note_success'));

      fetchNotes();
    } catch (error) {
      console.error("Lỗi tạo ghi chú từ ChatPanel:", error);
      toast.error(t('right_sidebar.manage_note.add_note_failed'));
    }
  }

  //SEND MESSAGE
  const handleSend = async () => {
    if (!input.trim()) return;

    try {
      let convId = conversationId
      
      // Nếu chưa có conversation → tạo mới
      if (!convId) {
        const newVisitorId = localStorage.getItem("visitorId") || uuidv4();
      
        const res = await ConversationAPI.createConversation(channelId, newVisitorId);
        convId = res.id;

        setCurrentChatId(res.id);
        setConversationId(convId);
        setSelectedConversationId(convId);
        localStorage.setItem("conversationId", convId);

        // cập nhật lại danh sách
        // setConversationList((prev) => [res, ...prev]);
        // await refreshConversationList()
      }

      const clientTempId = uuidv4();
      const tempMessage = {
        id: clientTempId,
        clientTempId,              
        message: input,
        isCustomer: true,
        createdAt: new Date().toISOString(),
      };

      setMessages((prev) => [...prev, tempMessage]);

      // Gửi tin nhắn sau khi đảm bảo có conversation
      const fileUrl = selectedFileForChat?.url || "";
      const titleFile = selectedFileForChat?.title || "";
      await ChatAPI.sendMessageV2(convId, input, titleFile, fileUrl);
      

      setConversationList((prevList) =>
        prevList.map((conv) => {
          if (conv.id === convId) {
            const isNewConversation = !conv.firstReplyMessage;

            return {
              ...conv,
              ...(isNewConversation && {
                firstMessage: input,
                firstReplyMessage: "(Đang trả lời...)",
              }),
              updatedAt: new Date().toISOString(),
            };
          }
          return conv;
        })
      );

      // setTimeout(() => {
        setLoadingConversations(prev => ({
          ...prev,
          [convId]: true
        }));
      // }, 1000);

      setInput("");
      setFileUrl("");
      setSelectedFileForChat(null);
    } catch (err) {
      console.error("Gửi tin thất bại:", err);
    }
  };

  useEffect(() => {
    if (!conversationId) return;

    const lastTime =
      messages.length > 0
        ? messages[messages.length - 1]?.createdAt?.time || Date.now()
        : Date.now();

    const messagesRef = dbRef(db, `/channels/${channelId}`);

    const q = query(messagesRef, orderByChild("createdAt/time"), startAt(lastTime + 1));

    const unsubscribe = onChildAdded(q, (snapshot) => {
      const rawMsg = snapshot.val();
      if (!rawMsg || rawMsg.conversationId !== conversationId) return;

      // Ensure message has an ID to act as a stable React key
      const msg = {
        ...rawMsg,
        id: rawMsg.id || snapshot.key
      };

      setMessages((prev) => {
        if (msg.isCustomer) {
          return [
            ...prev.filter(
              (m) => !(m.clientTempId && m.isCustomer && m.message === msg.message)
            ),{
              ...msg,
              isStreaming: false,
              isHistorical: false,
            }
            
          ];
        }

        // Helper: reset timeout để detect khi bot dừng stream
        const resetStreamTimeout = () => {
          if (botStreamTimeout.current) {
            clearTimeout(botStreamTimeout.current);
          }
          botStreamTimeout.current = setTimeout(() => {
            setMessages((prev) => {
              if (prev.length === 0) return prev;
              const hasStreaming = prev.some(m => m.isStreaming);
              if (!hasStreaming) return prev;
              return prev.map(m => m.isStreaming ? { ...m, isStreaming: false } : m);
            });
          }, 2000); // sau 2 giây không có chunk mới -> coi như kết thúc
        };

        // Nếu là tin nhắn từ Bot
        const lastMsg = prev[prev.length - 1];

        if (lastMsg && !lastMsg.isCustomer) {
          const timeM = msg.createdAt?.time || new Date(msg.createdAt).getTime() || 0;
          const timeLast = lastMsg.createdAt?.time || new Date(lastMsg.createdAt).getTime() || 0;

          if (Math.abs(timeM - timeLast) <= 60000) {
            // Append chunk vào bubble bot cuối
            const updated = {
              ...lastMsg,
              createdAt: msg.createdAt, // updated with latest chunk timestamp
              message: (lastMsg.message || "") + (msg.message || "") + '\n',
              isHistorical: false,
              isStreaming: true, 
              mode: msg.mode || lastMsg.mode
            };

            resetStreamTimeout();
            return [...prev.slice(0, -1), updated];
          } else {
            // Nếu khoảng cách lớn hơn 60s, tách thành bubble riêng (ví dụ admin trả lời)
            msg.message += '\n';
            resetStreamTimeout();
            return [
              ...prev,
              {
                ...msg,
                isStreaming: true,
                isHistorical: false,
              },
            ];
          }
        }
        // Fallback for title (first message)
        msg.message += '\n'
        resetStreamTimeout();
        return [
          ...prev,
          {
            ...msg,
            isStreaming: true,
            isHistorical: false,
          },
        ];
      });

      if (!msg.isCustomer) {
        setTimeout(() => {
          refreshConversationList();
        }, 1000);
        setLoadingConversations(prev => ({
          ...prev,
          [msg.conversationId]: false
        }));
      }
    });

    return () => {
      unsubscribe();
      if (botStreamTimeout.current) {
        clearTimeout(botStreamTimeout.current);
        botStreamTimeout.current = null;
      }
      // Clear any stuck streaming states when switching conversations
      setMessages((prev) => {
        const hasStreaming = prev.some(m => m.isStreaming);
        if (!hasStreaming) return prev;
        return prev.map(m => m.isStreaming ? { ...m, isStreaming: false } : m);
      });
    };
  }, [conversationId]);

  useLayoutEffect(() => {
    if (loadingHistory || skipScrollOnHistoryLoad.current) return;

    if (messages.length > 0 && pendingScrollForChatId.current === conversationId) {
      const lastUserMsgIndex = [...messages].reverse().findIndex(m => m.isCustomer);
      if (lastUserMsgIndex !== -1) {
        const actualIndex = messages.length - 1 - lastUserMsgIndex;
        const el = document.getElementById(`message-index-${actualIndex}`);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
          pendingScrollForChatId.current = null;
          return;
        }
      }
      chatEndRef.current?.scrollIntoView({ behavior: "auto" });
      pendingScrollForChatId.current = null;
    } else {
      if (pendingScrollForChatId.current === null) {
        // give it a tiny delay for subsequent regular updates
        setTimeout(() => {
          chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 50);
      }
    }
  }, [messages, conversationId, loadingHistory]);


  useEffect(() => {
    const node = chatContainerRef.current;
    node?.addEventListener("scroll", handleScroll);
    return () => node?.removeEventListener("scroll", handleScroll);
  }, [conversationId, pageMessageHistory, loadingHistory]);

  //LIKE-UNLIKE MESSAGE
  const handleLikeMessage = async (messageId, action) => {
    const targetMsg = messages.find((msg) => msg.id === messageId);
    if (!targetMsg) return;

    const currentStatus = targetMsg.isLike;
    let newStatus = null;

    if (action === "like") {
      newStatus = currentStatus === true ? null : true;
    } else if (action === "unlike") {
      newStatus = currentStatus === false ? null : false;
    }

    try {
      await ChatAPI.updateLikeStatus(messageId, newStatus);
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === messageId ? { ...msg, isLike: newStatus } : msg
        )
      );
    } catch (err) {
      console.error("Lỗi khi cập nhật trạng thái like:", err);
    }
  };

  const handleRedoMessage = async (botMessageId) => {
    // Tìm index tin bot
    const botIndex = messages.findIndex((msg) => msg.id === botMessageId && !msg.isCustomer);
    if (botIndex === -1) return;

    // Tìm tin user ngay trước đó
    const prevUserMsg = [...messages]
      .slice(0, botIndex)
      .reverse()
      .find((msg) => msg.isCustomer);

    if (!prevUserMsg) return;

    // Nếu có file đính kèm thì lấy URL
    let fileUrl = "";
    let titleFile = "";
    if (prevUserMsg.attachments?.length > 0) {
      const fileAttachment = prevUserMsg.attachments.find(att => att.type === "file" && att.payload?.url);
      if (fileAttachment) {
        fileUrl = fileAttachment.payload.url;
        titleFile = fileAttachment.title;
      }
    }

    try {
      let convId = conversationId;
      if (!convId) {
        const newVisitorId = localStorage.getItem("visitorId") || uuidv4();
        const res = await ConversationAPI.createConversation(channelId, newVisitorId);
        convId = res.id;
        setCurrentChatId(res.id);
        setConversationId(convId);
        setSelectedConversationId(convId);
        localStorage.setItem("conversationId", convId);
        await refreshConversationList();
      }

      const clientTempId = uuidv4();
      const tempMessage = {
        ...prevUserMsg,
        id: clientTempId,
        clientTempId,
        message: prevUserMsg.message,
        isCustomer: true,
        createdAt: new Date().toISOString(),
        isHistorical: false,
      };

      setMessages((prev) => [...prev, tempMessage]);

      // Gửi lại tin kèm file nếu có
      await ChatAPI.sendMessageV2(convId, prevUserMsg.message, titleFile, fileUrl);

      // setLoadingConversations(true)
      setLoadingConversations(prev => ({
        ...prev,
        [convId]: true
      }));
    } catch (err) {
      console.error("Gửi lại tin thất bại:", err);
    }
  };

  const handleSendQuickQuestion = async (question) => {
    try {
      let convId = conversationId;
      
      // Nếu chưa có conversation → tạo mới
      if (!convId) {
        const newVisitorId = localStorage.getItem("visitorId") || uuidv4();
        const res = await ConversationAPI.createConversation(channelId, newVisitorId);
        convId = res.id;
        setCurrentChatId(res.id);
        setConversationId(convId);
        setSelectedConversationId(convId);
        localStorage.setItem("conversationId", convId);
        // Cập nhật lại danh sách conversation
        // setConversationList((prev) => [res, ...prev]);
        // await refreshConversationList();
      }

      const clientTempId = uuidv4();
      const tempMessage = {
        id: clientTempId,
        clientTempId,
        message: question,
        isCustomer: true,
        createdAt: new Date().toISOString(),
      };

      // Hiển thị ngay tin nhắn quick question
      setMessages((prev) => [...prev, tempMessage]);

      // Gửi tới API
      await ChatAPI.sendMessageV2(convId, question);

      // setLoadingConversations(true);
      setLoadingConversations(prev => ({
        ...prev,
        [convId]: true
      }));
    } catch (err) {
      console.error("Gửi quick question thất bại:", err);
    }
  };

  useEffect(() => {
    // Reset input và state khi đổi conversation
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setSelectedFileForChat(null); 
    setInput("");
  }, [conversationId]);

  //CONFIG CHATWEB
  useEffect(() => {
    const fetchConfigChatweb = async () => {
      try {
        const data = await ConfigChatwebAPI.getConfigChatweb(channelId);
        setConfigChatweb(data);
      } catch (error) {
        console.error("Lỗi lấy cấu hình chatweb:", error);
      }
    };

    if (channelId) fetchConfigChatweb();
  }, [channelId]);
  
  return (
    <div className='bg-gray-50 flex overflow-hidden h-[80vh] md:h-[100vh]' 
      // style={{ height: "100vh" }}
      >
      <LoadingPage isOpen={isLoading}/>

      {/* Input file chung */}
      <input
        type="file"
        accept=".pdf,.doc,.docx,.txt,.html,.xls,.xlsx,.csv"
        multiple
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(e) => {
          handleFileUpload(e.target.files, true);
          e.target.value = "";
        }}
      />
      {/* <Sidebar 
        handleNewChat={handleNewChat}
        conversationList={conversationList}
        handleSelectConversation={handleSelectConversation}
        handleDeleteChatConversation={handleDeleteChatConversation}
        handleEditChatTitle={handleEditChatTitle}
        currentChatId={currentChatId}
      /> */}
      {/* <ChatPanel 
        key={chatKey}
        applicationID={applicationID}
        channelId={channelId}
        baseUrl={baseUrl}
        visitorId={visitorId}
        handleSend={handleSend}
        handleScroll={handleScroll}
        pageMessageHistory={pageMessageHistory}
        chatContainerRef={chatContainerRef}
        messages={messages}
        chatEndRef={chatEndRef}
        input={input}
        setInput={setInput}
        selectedFileForChat= {selectedFileForChat}
        setActiveRightSection={setActiveRightSection}
        handleSaveMessageToNote={handleSaveMessageToNote}
        loadingConversations={loadingConversations} 
        isLoading={isLoading}
        handleLikeMessage={handleLikeMessage}
        fileInputRef={fileInputRef}
        handleRedoMessage={handleRedoMessage}
        handleSendQuickQuestion={handleSendQuickQuestion}
        currentChatId={currentChatId}
      /> */}
      {/* <RightSidebar 
        activeRightSection={activeRightSection}
        setActiveRightSection={setActiveRightSection}
        documentFiles={documentFiles}
        handleFileUpload={handleFileUpload}
        handleSelect={handleSelect}
        handleDeleteDocument={handleDeleteDocument}
        noteList={noteList}
        newNoteTitle={newNoteTitle}
        setNewNoteTitle={setNewNoteTitle}
        newNoteContent={newNoteContent}
        setNewNoteContent={setNewNoteContent}
        handleAddNote={handleAddNote}
        handleEditNote={handleEditNote}
        editingNoteId={editingNoteId}
        isAddingNote={isAddingNote}
        setIsAddingNote={setIsAddingNote}
        handleSaveEditedNote={handleSaveEditedNote}
        handleDeleteNote={handleDeleteNote}
        selectedFileForChat= {selectedFileForChat}
        fileInputRef={fileInputRef}
      /> */}


      <div className={`hidden md:flex transition-all duration-300 ${desktopSidebarCollapsed ? 'w-[68px] opacity-100' : 'w-[350px] opacity-100'}`}>
        <Sidebar 
            handleNewChat={handleNewChat}
            conversationList={conversationList}
            handleSelectConversation={handleSelectConversation}
            handleDeleteChatConversation={handleDeleteChatConversation}
            handleEditChatTitle={handleEditChatTitle}
            currentChatId={currentChatId}
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            desktopSidebarCollapsed={desktopSidebarCollapsed}
            setDesktopSidebarCollapsed={setDesktopSidebarCollapsed}
            configChatweb={configChatweb}
          />
      </div>
      {showSidebar && (
        <div className="fixed inset-0 z-[60] md:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setShowSidebar(false)}></div>
          <div className="absolute inset-y-0 left-0 w-[350px] bg-white shadow-lg">
            <div className="h-full flex flex-col">
              <Sidebar 
                handleNewChat={handleNewChat}
                conversationList={conversationList}
                handleSelectConversation={handleSelectConversation}
                handleDeleteChatConversation={handleDeleteChatConversation}
                handleEditChatTitle={handleEditChatTitle}
                currentChatId={currentChatId}
                showSidebar={showSidebar}
                setShowSidebar={setShowSidebar}
                configChatweb={configChatweb}
              />
            </div>
          </div>
        </div>
      )}

      {/* Chat Panel (luôn hiện) */}
      <div className="flex-1 flex flex-col h-full mx-auto w-full">
        <ChatPanel 
          key={chatKey}
          applicationID={applicationID}
          channelId={channelId}
          baseUrl={baseUrl}
          visitorId={visitorId}
          handleSend={handleSend}
          handleScroll={handleScroll}
          pageMessageHistory={pageMessageHistory}
          chatContainerRef={chatContainerRef}
          messages={messages}
          chatEndRef={chatEndRef}
          input={input}
          setInput={setInput}
          selectedFileForChat= {selectedFileForChat}
          setActiveRightSection={setActiveRightSection}
          handleSaveMessageToNote={handleSaveMessageToNote}
          loadingConversations={loadingConversations} 
          isLoading={isLoading}
          handleLikeMessage={handleLikeMessage}
          fileInputRef={fileInputRef}
          handleRedoMessage={handleRedoMessage}
          handleSendQuickQuestion={handleSendQuickQuestion}
          currentChatId={currentChatId}
          setShowSidebar={setShowSidebar}
          setShowRightSidebar={setShowRightSidebar}
          showSidebar={showSidebar}
          desktopSidebarCollapsed={desktopSidebarCollapsed}
          setDesktopSidebarCollapsed={setDesktopSidebarCollapsed}
          setSelectedFileForChat={setSelectedFileForChat}
          documentFiles={documentFiles}
          configChatweb={configChatweb}
          isFetchingChat={isFetchingChat}
        />
      </div>


      {/* Right Sidebar */}
      <div className="hidden xl:flex">
        <RightSidebar 
          activeRightSection={activeRightSection}
          setActiveRightSection={setActiveRightSection}
          documentFiles={documentFiles}
          handleFileUpload={handleFileUpload}
          handleSelect={handleSelect}
          handleDeleteDocument={handleDeleteDocument}
          noteList={noteList}
          newNoteTitle={newNoteTitle}
          setNewNoteTitle={setNewNoteTitle}
          newNoteContent={newNoteContent}
          setNewNoteContent={setNewNoteContent}
          handleAddNote={handleAddNote}
          handleEditNote={handleEditNote}
          editingNoteId={editingNoteId}
          isAddingNote={isAddingNote}
          setIsAddingNote={setIsAddingNote}
          handleSaveEditedNote={handleSaveEditedNote}
          handleDeleteNote={handleDeleteNote}
          selectedFileForChat= {selectedFileForChat}
          fileInputRef={fileInputRef}
          setShowRightSidebar={setShowRightSidebar}
          showRightSidebar={showRightSidebar}
          configChatweb={configChatweb}
        />
      </div>
      {showRightSidebar && (
        <div className="fixed inset-0 z-40 xl:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setShowRightSidebar(false)}></div>
          <div className="absolute inset-y-0 right-0 w-80 bg-white shadow-lg">
            <RightSidebar 
              activeRightSection={activeRightSection}
              setActiveRightSection={setActiveRightSection}
              documentFiles={documentFiles}
              handleFileUpload={handleFileUpload}
              handleSelect={handleSelect}
              handleDeleteDocument={handleDeleteDocument}
              noteList={noteList}
              newNoteTitle={newNoteTitle}
              setNewNoteTitle={setNewNoteTitle}
              newNoteContent={newNoteContent}
              setNewNoteContent={setNewNoteContent}
              handleAddNote={handleAddNote}
              handleEditNote={handleEditNote}
              editingNoteId={editingNoteId}
              isAddingNote={isAddingNote}
              setIsAddingNote={setIsAddingNote}
              handleSaveEditedNote={handleSaveEditedNote}
              handleDeleteNote={handleDeleteNote}
              selectedFileForChat= {selectedFileForChat}
              fileInputRef={fileInputRef}
              setShowRightSidebar={setShowRightSidebar}
              showRightSidebar={showRightSidebar}
              configChatweb={configChatweb}
            />
          </div>
        </div>
      )}

    </div>
  )
}

export default ChatPage